/**
 * DataTableProps of a tab whose table hangs from the profile endpoint: the profile endpoint plus
 * the tab `endpoint` of its config. A config that brings its own `DataTableProps.endpoint` keeps it.
 * @param {Object} params
 * @param {string} params.profileEndpoint `${ENTITIES.<entity>.endpoint}/${profile.id}`
 * @param {{ endpoint: string, DataTableProps: Object }} params.tabConfig <Entity>TabsConfig[<Entity>TabIds.X]
 * @returns {Object} DataTableProps with `endpoint`
 */
export const buildTabDataTableProps = ({ profileEndpoint, tabConfig }) => ({
  endpoint: `${profileEndpoint}/${tabConfig.endpoint}`,
  ...tabConfig.DataTableProps
});
